import { fallback, maxValue, minValue, nullable, number, optional, pipe, type InferOutput } from "valibot"
import { ELEVATION_ABSOLUTE_MAX, ELEVATION_ABSOLUTE_MIN, FALLBACK_ELEVATION } from "./elevation_consts"

export const EntityElevationSchema = fallback(
  pipe(
    number(), 
    minValue(ELEVATION_ABSOLUTE_MIN), 
    maxValue(ELEVATION_ABSOLUTE_MAX)
  ), 
  FALLBACK_ELEVATION
)

export type EntityElevation = InferOutput<typeof EntityElevationSchema>

export const NullableEntityElevationSchema = nullable(EntityElevationSchema)

export type NullableEntityElevation = InferOutput<typeof NullableEntityElevationSchema>

export const OptionalNullableEntityElevationSchema = optional(NullableEntityElevationSchema)

export type OptionalNullableEntityElevation = InferOutput<typeof OptionalNullableEntityElevationSchema>